import { useFeatureFlag } from '@artic/ui/feature-flags';
import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OperationsStationsGridView } from '../../features/operations-stations-grid/operations-stations-grid-view';

export const Route = createFileRoute('/operations-stations-grid/')({
  component: OperationsStationsGridPage,
});

function OperationsStationsGridPage() {
  const enabled = useFeatureFlag('settings_factory');
  const partnerId = usePartnerId();

  if (!enabled) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Feature not available</h2>
        <p className="text-muted-foreground text-sm">
          Factory settings in Quality are not enabled for your organisation.
        </p>
      </div>
    );
  }

  return <OperationsStationsGridView partnerId={partnerId} />;
}
